/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decline_ErrorInputs */

const en_decline_error = /** @type {(inputs: Decline_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error: application could not be declined`)
};

const de_decline_error = /** @type {(inputs: Decline_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler: Bewerbung konnte nicht abgelehnt werden`)
};

/**
* | output |
* | --- |
* | "Error: application could not be declined" |
*
* @param {Decline_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const decline_error = /** @type {((inputs?: Decline_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decline_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_decline_error(inputs)
	return en_decline_error(inputs)
});